import styled from 'styled-components';

import { type Theme } from '@/utils/theme/themes';

export function gridColorSelector(theme: Theme, shade: 'major' | 'minor') {
  return shade === 'major' ? theme.palette.fg800 : theme.palette.fg500;
}

export const ContentMarginLine = styled.div<{
  'data-bottom'?: boolean;
  'data-minor'?: boolean;
  'data-right'?: boolean;
  'data-top'?: boolean;
}>`
  --border-color: ${({ theme }) => gridColorSelector(theme, 'major')};

  grid-column: 1;
  border-right: 1px solid var(--border-color);
  align-self: stretch;

  &[data-right] {
    grid-column: -1;
    border-right: none;
    border-left: 1px solid var(--border-color);
  }

  &[data-minor] {
    --border-color: ${({ theme }) => gridColorSelector(theme, 'minor')};
  }

  &[data-top] {
    border-top: 1px solid ${({ theme }) => gridColorSelector(theme, 'minor')};
  }

  &[data-bottom] {
    border-bottom: 1px solid ${({ theme }) => gridColorSelector(theme, 'minor')};
  }

  &[data-v1-gridlines] {
    background-image: linear-gradient(
      to bottom,
      transparent calc(100% - 1px),
      ${({ theme }) => gridColorSelector(theme, 'minor')} calc(100% - 1px)
    );
    background-size: 100% 10rem;
  }
`;

export const GridRule = styled.div<{
  $column?: number;
}>`
  align-self: stretch;
  justify-self: flex-end;
  width: 1px;
  background-color: ${({ theme }) => gridColorSelector(theme, 'minor')};
  grid-column: ${({ $column }) => $column || 1};
  transform: translateX(50%);
`;
